<template>
  <BaseSelect
    v-model="modelValue"
    v-bind="$attrs"
    :options="options"
    label="Currency"
    size="sm"
    rules="required"
  >
    <template v-slot:label>
      Currency <span class="text-danger">*</span>
    </template>

    <template v-slot:first>
      <b-form-select-option :value="undefined" disabled
        >Select Currency</b-form-select-option
      >
    </template>
  </BaseSelect>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { BDX_CURRENCY_TYPES, KEEP_AS_IS_OPTION } from '@constants'
import { BaseSelect } from '@components/base'

export default defineComponent({
  name: 'BDXEditFormCurrency',
  components: {
    BaseSelect
  },
  props: {
    value: String,
    useKeepAsIsOption: Boolean,
  },
  emits: ['input'],
  setup(props, { emit }) {
    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })
    let options = BDX_CURRENCY_TYPES;
    if (props.useKeepAsIsOption) {
      options = [KEEP_AS_IS_OPTION, ...options];
    }

    return {
      options,
      modelValue
    }
  }
})
</script>
